import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";

export default {
  namespaced: true,
  state: {
    modes: null
  },
  getters: {
    showModes(state) {
      return state.modes;
    }
  },
  mutations: {
    setModes(state, modes) {
      state.modes = modes;
    }
  },
  actions: {
    async getModes({ commit }) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/mode/`
        );

        if (response.status == 200) {
          commit("setModes", response.data);
        }
        return response.data;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
